import { EPreferredLanguage } from "fungi-types";
import i18n from "~/modules/i18n";
const { t, locale } = i18n.global;

export function roundToDecimals(value: number, decimals: number): number {
  const rounder = 10 ** decimals;
  return Math.round(value * rounder) / rounder;
}

export function roundUpToDecimals(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  return Math.ceil(value * factor) / factor;
}

export const getHighestBelow100 = (array: number[]) => {
  let highest = -Infinity;
  let hasNumberBelow100 = false;

  for (let num of array) {
    if (num < 100 && num > highest) {
      highest = num;
      hasNumberBelow100 = true;
    }
  }

  return hasNumberBelow100 ? highest : 100;
};

export const formatNumberLocal = (value: number, localParam?: EPreferredLanguage) => {
  const lang = localParam || locale.value;
  if (lang === "fr") {
    return new Intl.NumberFormat("fr-FR").format(value);
  }
  return new Intl.NumberFormat("en-US").format(value);
};
